<template>
  <QDialog
    :value="value"
    position="left"
    full-height
    transition-show="slide-right"
    transition-hide="slide-left"
    content-class="vehicle-result-filter-drawer__backdrop-inner"
    aria-labelledby="vehicle-result-filter-drawer-title"
    @input="$emit('input', $event)"
  >
    <QCard class="lease-inclusion-dialog vehicle-result-filter-drawer vehicle-result-filter-drawer--panel column no-wrap full-height">
      <QCardSection class="vehicle-result-filter-drawer__header column q-pa-md q-pt-md q-pb-none full-width">
        <div
          class="row items-center no-wrap full-width vehicle-result-filter-drawer__header-nav"
          :class="refineMobileDetailOpen ? 'justify-between' : 'justify-end'"
        >
          <button
            v-if="refineMobileDetailOpen"
            type="button"
            class="vehicle-result-filter-drawer__back-btn"
            :disabled="disabled || submitLoading"
            @click="onDrawerRefineBack"
          >
            <QIcon :name="arrowBackOutline" color="primary" size="1.715em" class="vehicle-result-filter-drawer__back-btn-icon" />
            <span class="font-nunito vehicle-result-filter-drawer__back-btn-label">Back</span>
          </button>
          <QBtn
            rounded
            class="font-nunito calculator-dialog-close vehicle-result-filter-drawer__close-btn"
            flat
            :icon-right="closeIconCircle"
            size="16px"
            color="primary"
            align="left"
            @click="$emit('input', false)"
          >
            Close
          </QBtn>
        </div>
        <p
          id="vehicle-result-filter-drawer-title"
          class="
            text-primary
            font-nunito
            text-weight-bold
            q-pa-none q-mt-sm
            lease-inclusion-title
            vehicle-result-filter-drawer__filters-title
          "
        >
          Filters
        </p>
        <div
          v-if="showResetFilterButton || (refineMobileDetailOpen && stackCategoryHasFilters)"
          class="
            row
            q-col-gutter-sm
            no-wrap
            items-stretch
            vehicle-result-filter-drawer__sort-buttons vehicle-result-filter-drawer__reset-row
          "
        >
          <div
            v-for="colIndex in hasDrawerSortOptions ? sortOptions.length : 2"
            :key="'vehicle-result-filter-drawer-reset-col-' + colIndex"
            class="col"
            :aria-hidden="colIndex > 1 ? 'true' : undefined"
          >
            <CalculatorButton
              v-if="colIndex === 1"
              color="primary"
              rounded
              label="Reset filter"
              outlined
              class="full-width calculator-button vehicle-result-filter-drawer__reset-btn"
              @click="onResetFilterClick"
            />
          </div>
        </div>
      </QCardSection>
      <QCardSection class="vehicle-result-filter-drawer__body col q-pa-md q-pt-none scroll">
        <RefineSearchContainer
          ref="refine"
          :value="searchOptions"
          hide-submit-button
          mobile-stack-navigation
          :drawer-repayment="repayment"
          @input="handleSearchOptionsInput"
          @mobile-stack-detail="onMobileStackDetail"
          @active-mobile-category-has-filters="stackCategoryHasFilters = $event"
          :sortedBy="sortBy"
          :sortedOrder="sortOrder"
          :disabled="disabled"
          :pageSize="pageSize"
          :leaseTerm="leaseTerm"
          @submit="handleSubmit"
        />
        <div v-show="!refineMobileDetailOpen" class="vehicle-result-filter-drawer__sort-payments">
          <template v-if="hasDrawerSortOptions">
            <div class="vehicle-result-filter-drawer__divider" aria-hidden="true" />
            <div class="vehicle-result-filter-drawer__sort-block">
              <div class="vehicle-result-filter-drawer__sort-head row items-center no-wrap full-width q-mb-sm">
                <p class="text-primary text-weight-bolder vehicle-result-filter-drawer__section-label">Sort by</p>
                <QBtn
                  flat
                  dense
                  round
                  padding="xs"
                  class="vehicle-result-filter-drawer__sort-order-btn"
                  :disable="sortAndPaymentsDisabled"
                  aria-label="Toggle sort direction"
                  @click.stop="onDrawerSortOrderToggle"
                >
                  <FilterIcon :value="drawerSortOrderAscending" size="sm" color="grey-6" />
                </QBtn>
              </div>
              <div class="row q-col-gutter-sm no-wrap items-stretch vehicle-result-filter-drawer__sort-buttons">
                <div v-for="opt in sortOptions" :key="opt.value" class="col">
                  <CheckboxButton
                    rounded
                    full-width
                    :label="opt.label"
                    :value="isDrawerSortOptionSelected(opt)"
                    outlined
                    remove-opacity
                    :disabled="sortAndPaymentsDisabled || isDrawerSortOptionSelected(opt)"
                    @input="onDrawerSortOptionInput(opt, $event)"
                  />
                </div>
              </div>
            </div>
            <div class="vehicle-result-filter-drawer__divider" aria-hidden="true" />
          </template>
          <div v-else class="vehicle-result-filter-drawer__divider" aria-hidden="true" />
          <div class="vehicle-result-filter-drawer__payments-block">
            <RepaymentOptions
              class="vehicle-result-filter-drawer__repayment-options"
              :value="repayment"
              :is-active="true"
              full-width-buttons
              @input="$emit('update:repayment', $event)"
            />
          </div>
          <div class="vehicle-result-filter-drawer__divider" aria-hidden="true" />

          <CalculatorButton
            outlined
            class="col-12 calculator-button full-width"
            rounded
            label="Lease inclusions"
            @click="$emit('leaseInclusion')"
          />

          <div class="vehicle-result-filter-drawer__footer-spacer" aria-hidden="true" />
        </div>
      </QCardSection>
      <QCardSection v-show="!refineMobileDetailOpen" class="vehicle-result-filter-drawer__detail-footer q-pt-lg full-width no-border">
        <CalculatorButton
          color="primary"
          has-chevron-icon
          outlined
          class="col-12 calculator-button full-width"
          rounded
          label="Update search"
          :loading="submitLoading"
          :disabled="disabled || submitLoading"
          @click="handleFooterUpdateSearch"
        />
      </QCardSection>
      <QCardSection
        v-show="refineMobileDetailOpen"
        class="vehicle-result-filter-drawer__detail-footer q-pt-lg q-pt-none q-pb-none full-width"
      >
        <CalculatorButton
          type="button"
          color="primary"
          rounded
          class="col-12 calculator-button full-width"
          label="Add filters +"
          :disabled="disabled || submitLoading"
          @click="onMobileRefineAddFilters"
        />
      </QCardSection>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard, QCardSection, QBtn, QIcon } from 'quasar';
import { evaCloseCircleOutline, evaArrowBackOutline } from '@quasar/extras/eva-icons';
import RefineSearchContainer from '../RefineSearch/RefineSearchContainer';
import RepaymentOptions from '../RepaymentOptions';
import CalculatorButton from '../CalculatorButton';
import CheckboxButton from '../CheckboxButton';
import FilterIcon from '../Icon/FilterIcon';
import { REPAYMENT_WEEKLY } from '../../../utils/constants';
import { countVehicleResultSearchFilters } from '../../../utils/calculator/countVehicleResultSearchFilters';

/**
 * Mobile filter drawer: refine stack + sort/repay + Update search.
 * Sort/repay changes update parent state only; fetch + URL query (sortBy, sortOrder, budgetType)
 * run on "Update search" via RefineSearchContainer.submitSearch — desktop row actions unchanged.
 * Reset filter: on refine hub clears everything (parent @reset); inside a category drill-down clears that category only.
 */
export default {
  name: 'VehicleResultFilterDrawer',
  components: {
    QDialog,
    QCard,
    QCardSection,
    QBtn,
    QIcon,
    RefineSearchContainer,
    RepaymentOptions,
    CalculatorButton,
    CheckboxButton,
    FilterIcon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    searchOptions: {
      type: Object,
      default: () => ({}),
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 25
    },
    leaseTerm: {
      type: Object,
      default: () => ({ value: 60 })
    },
    sortBy: {
      type: Object,
      default: null
    },
    sortOrder: {
      type: String,
      default: 'ASC'
    },
    sortOptions: {
      type: Array,
      default: () => []
    },
    repayment: {
      type: String,
      default: 'weekly'
    },
    formattedVehicles: {
      type: Array,
      default: () => []
    },
    hasItemsInShortList: {
      type: Boolean,
      default: false
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    /** Same as MobileNavigation: adjusts refine-count when the Make hub row is hidden (≤1 make facet). */
    makeFacetOptionCount: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      closeIconCircle: evaCloseCircleOutline,
      arrowBackOutline: evaArrowBackOutline,
      /** True while mobile refine is on a category screen (Make, Model, …), not the hub. */
      refineMobileDetailOpen: false,
      /** True when the open stack category has at least one selection (from RefineSearchContainer). */
      stackCategoryHasFilters: false
    };
  },
  watch: {
    value(isOpen) {
      if (!isOpen) {
        this.refineMobileDetailOpen = false;
        this.stackCategoryHasFilters = false;
        if (this.$refs.refine && typeof this.$refs.refine.rsm_closeMobileFilterStack === 'function') {
          this.$nextTick(() => {
            if (this.$refs.refine) {
              this.$refs.refine.rsm_closeMobileFilterStack();
            }
          });
        }
      }
    }
  },
  computed: {
    sortAndPaymentsDisabled() {
      return this.disabled || this.submitLoading || !this.formattedVehicles || this.formattedVehicles.length === 0;
    },
    /** Mirrors prop default `sortOrder` so the direction icon stays consistent when parent omits sortOrder. */
    drawerSortOrderAscending() {
      return (this.sortOrder || 'ASC').toUpperCase() === 'ASC';
    },
    hasDrawerSortOptions() {
      return Array.isArray(this.sortOptions) && this.sortOptions.length > 0;
    },
    /** Matches mobile "Filters N" counting + legacy flat make/model query keys + sort/repay vs reset defaults. */
    showResetFilterButton() {
      return (
        this.refineSearchFilterCount > 0 ||
        this.hasLegacyFlatMakeModelFilters ||
        this.hasNonDefaultDrawerSort ||
        this.hasNonDefaultRepayment
      );
    },
    refineSearchFilterCount() {
      return countVehicleResultSearchFilters(this.searchOptions, {
        makeFacetOptionCount: this.makeFacetOptionCount
      });
    },
    hasLegacyFlatMakeModelFilters() {
      const o = this.searchOptions || {};
      const nonempty = (v) => {
        if (v == null) return false;
        if (Array.isArray(v)) return v.some((x) => x != null && String(x).trim() !== '');
        if (typeof v === 'string') return v.trim() !== '';
        return true;
      };
      return ['vehicleMake', 'vehicleModel', 'vehicleTrim'].some((k) => nonempty(o[k]));
    },
    hasNonDefaultDrawerSort() {
      const by = this.sortBy?.value ?? 'vehicle_description';
      const ord = String(this.sortOrder || 'ASC').toUpperCase();
      return by !== 'vehicle_description' || ord !== 'ASC';
    },
    hasNonDefaultRepayment() {
      return Boolean(this.repayment && this.repayment !== REPAYMENT_WEEKLY);
    }
  },
  methods: {
    onMobileStackDetail(open) {
      this.refineMobileDetailOpen = open;
      if (!open) {
        this.stackCategoryHasFilters = false;
      }
    },
    onResetFilterClick() {
      if (
        this.refineMobileDetailOpen &&
        this.$refs.refine &&
        typeof this.$refs.refine.rsm_resetActiveMobileCategoryFilters === 'function'
      ) {
        this.$refs.refine.rsm_resetActiveMobileCategoryFilters();
        return;
      }
      this.$emit('reset');
    },
    isDrawerSortOptionSelected(opt) {
      return Boolean(this.sortBy && this.sortBy.value === opt.value);
    },
    onDrawerSortOptionInput(opt, checked) {
      if (this.sortAndPaymentsDisabled || !checked) {
        return;
      }
      // Mobile drawer: defer fetch + URL until "Update search" (RefineSearchContainer submit).
      this.$emit('update:sortBy', opt);
    },
    onDrawerSortOrderToggle() {
      if (this.sortAndPaymentsDisabled) {
        return;
      }
      const next = this.drawerSortOrderAscending ? 'DESC' : 'ASC';
      this.$emit('update:sortOrder', next);
    },
    handleSearchOptionsInput(value) {
      this.$emit('update:searchOptions', value);
    },
    handleSubmit() {
      this.$emit('submit');
    },
    async handleFooterUpdateSearch() {
      if (this.$refs.refine && this.$refs.refine.submitSearch) {
        await this.$refs.refine.submitSearch();
      }
    },
    resetLocalState() {
      if (this.$refs.refine && this.$refs.refine.resetLocalState) {
        this.$refs.refine.resetLocalState();
      }
    },
    onDrawerRefineBack() {
      if (this.$refs.refine && typeof this.$refs.refine.rsm_mobileRefineBack === 'function') {
        this.$refs.refine.rsm_mobileRefineBack();
      }
    },
    onMobileRefineAddFilters() {
      if (this.$refs.refine && typeof this.$refs.refine.rsm_closeMobileFilterStack === 'function') {
        this.$refs.refine.rsm_closeMobileFilterStack();
      }
    }
  }
};
</script>
